module.exports = __webpack_public_path__ + "static/img/AAV_腺相关病毒包装banner.1d9677a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/二级标题Banner/AAV_腺相关病毒包装banner.jpg
// module id = wYSH
// module chunks = 1